<div class="mx-auto w-[90%]">
  <div class="mb-6 mt-10 flex justify-between text-center">
    <h1 class="text-start text-3xl font-bold">Crear SEPA</h1>
    <div class="flex gap-4">
      <app-loading-button
        [text]="'Guardar'"
        [icon]="'save'"
        [loading]="isLoading"
        [disabled]="newSepaForm.invalid || newSepaForm.pending"
        (clicked)="crearSepa()"
      />
    </div>
  </div>

  <form [formGroup]="newSepaForm" class="mx-auto mb-32 w-[100%] space-y-6">
    <div class="card-shadow space-y-4 rounded-md p-4">
      <h2 class="mb-4 text-2xl font-semibold text-field-green">Datos de la remesa</h2>
      <div class="grid grid-cols-2 gap-4 rounded-md bg-seasalt">
        <!-- EMPRESA FACTURADORA -->
        <div>
          <label for="empresaFacturadoraId" class="block text-sm font-medium">Empresa</label>
          <select
            id="empresaFacturadoraId"
            formControlName="empresaFacturadoraId"
            class="delay-50 border-1 form-select mt-1 block w-full rounded-md border-dark-blue shadow-sm transition ease-in focus:border-medium-green focus:ring focus:ring-medium-green focus:ring-opacity-50"
          >
            <option *ngFor="let empresa of empresasRefacturadoras" [value]="empresa.id">
              {{ empresa.nombreEmpresa }}
            </option>
          </select>
          <app-form-errors fieldName="empresaFacturadoraId" />
        </div>
        <!-- CUENTA BANCARIA -->
        <div>
          <label for="cuentaBancariaId" class="block text-sm font-medium">Cuenta bancaria</label>
          <select
            id="cuentaBancariaId"
            formControlName="cuentaBancariaId"
            class="delay-50 border-1 form-select mt-1 block w-full rounded-md border-dark-blue shadow-sm transition ease-in focus:border-medium-green focus:ring focus:ring-medium-green focus:ring-opacity-50"
          >
            <option *ngFor="let cuenta of cuentasBancarias" [value]="cuenta.id">
              {{ cuenta.banco }} - {{ cuenta.numeroCuenta }}
            </option>
          </select>
          <app-form-errors fieldName="cuentaBancariaId" />
        </div>
      </div>
      <div class="grid grid-cols-2 gap-4 rounded-md bg-seasalt">
        <div>
          <app-input-fecha
            [formGroup]="newSepaForm"
            controlName="fechaEmision"
            label="Fecha de emisión de las facturas"
          />
        </div>
        <div>
          <app-input-fecha [formGroup]="newSepaForm" controlName="fechaCargo" label="Fecha de cargo al cliente" />
        </div>
      </div>
      <div class="grid grid-cols-1 gap-4">
        <app-input-textarea label="Observaciones de SEPA" [formGroup]="newSepaForm" controlName="observaciones" />
      </div>
    </div>
    <div class="card-shadow rounded-md p-4">
      <h2 class="mb-4 text-xl font-semibold text-field-green">Facturas Seleccionables</h2>

      <!-- SELECTOR DE COLUMNAS-->
      <div class="relative flex gap-4">
        <button
          (click)="toogleColumnDropdown()"
          class="btn flex items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:border-field-green hover:bg-seasalt hover:text-dark-blue"
        >
          {{ isColumnDropdownOpen ? 'Ocultar menú de columnas' : 'Mostrar menú de columnas' }}
        </button>
        <div *ngIf="isColumnDropdownOpen" class="dropdown-menu">
          <div
            *ngFor="let option of columnOptions"
            (click)="toggleColumnaSeleccionada(option)"
            [class.selected]="option.selected"
          >
            {{ option.headerName }}
          </div>
        </div>
      </div>

      <div class="mt-4">
        <app-form-errors class="mb-2" fieldName="facturas" />
        <ag-grid-angular
          style="min-width: 100%"
          class="ag-theme-quartz mx-auto"
          [columnDefs]="columnDefs"
          [gridOptions]="gridOptions"
          [rowData]="facturasParaSepa"
          rowSelection="multiple"
          (gridReady)="onGridReady($event)"
        />
      </div>
    </div>
  </form>
</div>
